import React from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';

import styles from './styles.module.css';

export function SizeBox({
  name,
  value,
  isSelected,
  handleClick,
}: {
  name: string;
  value: string;
  isSelected: boolean;
  handleClick: (value: string) => void;
}) {
  return (
    <label className={styles.sizeButton}>
      <Body variant="sm-regular" className={styles.sizeButtonText}>
        {name}
      </Body>

      <input
        type="checkbox"
        onChange={() => handleClick(value)}
        checked={isSelected}
        value={value}
        className={styles.nativeCheckbox}
      />
    </label>
  );
}
